'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  wrapper: {
    width: '100%'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/Drawer/BasicDrawer/styles.js
// module id = 622
// module chunks = 61549186969478 79611799117203